import Magistrado from '@/model/Magistrado';
import { uiStore } from '@/store';
import { mapToPageablePayload } from '@/utils/ApiUtils';
import { RestApi } from '@pjn/ajax/Api';
import { AxiosInstance } from '@pjn/ajax/HttpClient';
import { OptionalId } from '@pjn/core/model/helpers/Types';
import { toEntity } from '@pjn/ajax/helpers';
import Expediente from '@/model/Expediente';

/** URL base de la API de magistrados */
const EXPEDIENTE_URL = process.env.VUE_APP_DENUNCIAS_URL + '/expediente';


export class ExpedienteRestApi extends RestApi<Magistrado> {
  constructor(http: AxiosInstance) {
    super(http, EXPEDIENTE_URL);
  }
  save(expediente: OptionalId<Expediente>) {

    return this.http
      .put(`${EXPEDIENTE_URL}`, expediente)
      .then(toEntity<Expediente>())
      .catch(error => {
        throw error;
      });
  }
    createExpediente(expediente: OptionalId<Expediente> ) {
    return this.http
      .post(
        `${EXPEDIENTE_URL}`, expediente )
      .then(toEntity<Expediente>());
    }

    findById(id: number) {
    return this.http
      .get(`${EXPEDIENTE_URL}` + '/' + id)
      .then(toEntity<Expediente>())
      .catch(error => {
        if (error.code !== '4033') {
          uiStore.notification.error(error);
        }
        return Promise.reject(error);
      });
    }
    findByNumeroAnio(numero: number, anio: number) {
    return this.http
      .get(`${EXPEDIENTE_URL}/${numero}/${anio}`)
      .then(toEntity<Expediente>())
      
      .catch(error => {
        return Promise.reject(error.message || error);
      });
    }
    
    deleteExpediente(id: number) {
    return this.http
      .delete(`${EXPEDIENTE_URL}` + '/' + id)
      .catch(error => {
          uiStore.notification.error(error);
          return Promise.reject(error.message || error);
      });
  }
    
  async getExpedientes(query: string) {
    const response = await this.http.get(`${EXPEDIENTE_URL}${query}&sort=resolucion.anio,desc&sort=resolucion.numero,desc`).catch(error => {
      uiStore.notification.error(error.message || error);
      return Promise.reject(error.message || error);
    });
    return mapToPageablePayload<Expediente>(response.data)
  }

}
